import { extractStringValueSet } from './extract-properties';

export default class NotificationType {

    static readonly Created: string = 'created';
    static readonly Updated: string = 'updated';
    static readonly Canceled: string = 'canceled';
    static readonly ItemAdded: string = 'item-added';
    static readonly ItemUpdated: string = 'item-updated';
    static readonly AddedChangeReason: string = 'added-change-reason';

    private static _valueSet: Set<string> = null;
    static get values(): Set<string> {

        if (!this._valueSet) {
            this._valueSet = extractStringValueSet(this);
        }
        return new Set(this._valueSet);
    }
}
